export const GetUserId = () => {
  const data = localStorage.getItem('userData');
  const id = JSON.parse(data)?.email;
  return id ? id : '';
};


export const GetUserName = () => {
  const data = localStorage.getItem('userData');
 console.log("localStorage data",data)
  const id = JSON.parse(data)?.name;
  return id ? id : '';
};